import { type FC } from "react";
import { Box, Button as ChakraButton, type ButtonProps as ChakraButtonProps } from "@chakra-ui/react";

type ButtonProps = ChakraButtonProps;

// fix for Chakra Button's spinner that gives a memory leak in development... for some reason
export const Button: FC<ButtonProps> = ({ spinner, children, isLoading, ...rest }) => {
	if (isLoading && spinner) {
		return (
			<ChakraButton {...rest}>
				<Box as="span" opacity={0}>{children}</Box>
				{spinner}
			</ChakraButton>
		);
	}

	return <ChakraButton {...rest}>{children}</ChakraButton>
}